module.exports = __webpack_public_path__ + "static/media/inspection.9d62cb23.svg";